import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { ActivatedRoute } from '@angular/router';
import axios from 'src/app/Service/axios';

@Component({

  selector: 'app-taxilon-tariff',

  templateUrl: './taxilon-tariff.component.html',

  styleUrls: ['./taxilon-tariff.component.css']

})

export class TaxilonTariffComponent implements OnInit {

  bEmdadRan: boolean = false;

  tabView: number = 0;

  _itemIndex: number = -1;

  lst_State: any[] = [];

  lst_Search: any[] = [];

  lst_GroupCar: any = [];

  lst_MobileDomain: any[] = [];

  mdl_State: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    fTariffFactor: new FormControl(''),

    strState: new FormControl(''),

    strStateName: new FormControl(''),

  })

  mdl_MobileGroup: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iTaxiLon_Tariff: new FormControl(''),

    iMobileDomain: new FormControl('', Validators.required),

    tiMobileGroup: new FormControl('', Validators.required),

    iInputAmount: new FormControl('0', [Validators.required, Validators.min(0)]),

    iPerKm: new FormControl('0', [Validators.required, Validators.min(0)]),

    iStoppageFee: new FormControl('0', [Validators.required, Validators.min(0)]),

    iTraffic: new FormControl('0', [Validators.required, Validators.min(0)]),

    iEvenOdd: new FormControl('0', [Validators.required, Validators.min(0)]),

    iPreparation: new FormControl('0', [Validators.required, Validators.min(0)]), //

    tiBadWetherPercentage: new FormControl('0', [Validators.required, Validators.max(200), Validators.min(0)]), //

    tiMountainousPercentage: new FormControl('0', [Validators.required, Validators.max(200), Validators.min(0)]), //

    tiNightlyPercentage: new FormControl('0', [Validators.required, Validators.max(200), Validators.min(0)]),

    tiDiscountPercentage: new FormControl('0', [Validators.required, Validators.max(200), Validators.min(0)]),

    tiComeBackPercentage: new FormControl('0', [Validators.required, Validators.max(200), Validators.min(0)]),

    iSpatialDayPercentage: new FormControl('0', [Validators.required, Validators.max(200), Validators.min(0)]),

    tiCommissionPercentage: new FormControl('0', [Validators.required, Validators.max(200), Validators.min(0)]),

    tiAdvancePaymentPercentage: new FormControl('0', [Validators.required, Validators.max(200), Validators.min(0)]),

    tiType: new FormControl('1')

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private gurdService: GurdServiceService,

    private _other: OtherService,

    private _route: ActivatedRoute

  ) { }

  ngOnInit(): void {

    this._route.url.subscribe((segment: any) => {

      if (segment[0].path == 'tariff-2') {

        this.bEmdadRan = true;

        this.mdl_MobileGroup.patchValue({

          tiType: 2

        })

      }

    })

    this.setActiveTab(1);

    this.getMobileGroup();

  }

  setActiveTab(index: any) {

    this.tabView = index;

    switch (this.tabView) {
      case 1:
        this.getState_List();
        break;
      case 2:
        // this.getTripsList();
        break;
      default:
        break;
    }

  }

  async getState_List() {

    this.lst_State = [];

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`TaxiLon_State_List`, {})).data.toString());

    this._other.nonespinner();

    if (res.bError || res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_State = res;

    this.lst_Search = res;

    // ------------------------------------------------------

    this._other.Showspinner();

    const resp = await axios.post(`GetMobileDomain4Report?iSystemUser=${this.gurdService.decrypt(localStorage.getItem("ID")!)}`, {});

    let res_2 = JSON.parse(resp.data);

    if (res_2.bError) return this._tooltip.showError(res_2.strError);

    this.lst_MobileDomain = res_2;

    this._other.nonespinner();

  }

  async getMobileGroup() {

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`GetMobileGroup`, {})).data.toString());

    this._other.nonespinner();

    if (res.bError || res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_GroupCar = res;


  }

  filter_Result(strValue: string) {

    this.lst_State = this.lst_Search.filter((el: any) => {

      return el?.strStateName.includes(strValue)

    });

    if (strValue.trim() == '') {

      this.lst_State = this.lst_Search;

    }

  }

  editState(isDiscard: boolean = false, item: any = {}, index: number = -1) {

    if (isDiscard) {

      this.lst_State[this._itemIndex].isEdit = false;

    }

    else {

      if (this._itemIndex != -1 && this._itemIndex != index) {

        this.lst_State[this._itemIndex].isEdit = false;

        this.lst_State[this._itemIndex]

      }

      Object.keys(item).forEach(key => {

        this.mdl_State.get(key)?.setValue(item[key]);

      })

      this.lst_State[this._itemIndex = index].isEdit = true;

    }

  }

  async submit_State() {

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`TaxiLon_State_Edit`, this._other.stringNumberToNumber(this.mdl_State.value))).data.toString());

    this._other.nonespinner();

    if (res.bError || res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_State[this._itemIndex].isEdit = false;

    this.lst_State[this._itemIndex].fTariffFactor = res[0].fTariffFactor;

    this._tooltip.showSuccess('اطلاعات با موفقیت ویرایش شد')

  }

  async searchBy_Group() {

    if (this.mdl_MobileGroup.get('iMobileDomain')?.value == '') return this._tooltip.showError('حوزه خدمت را انتخاب کنید');

    if (this.mdl_MobileGroup.get('tiMobileGroup')?.value == '') return this._tooltip.showError('گروه خودرویی را انتخاب کنید');

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`TaxiLon_Tariff_MobileGroup`, this._other.stringNumberToNumber(this.mdl_MobileGroup.value))).data.toString());

    this._other.nonespinner();

    if (res.bError || res.iResult == 0) return this._tooltip.showError(res.strError);

    if (res.length) {

      this.mdl_MobileGroup.patchValue({

        iTaxiLon_Tariff: res[0].iTaxiLon_Tariff,

        iInputAmount: res[0].iInputAmount.toLocaleString(),

        iPerKm: res[0].iPerKm.toLocaleString(),

        iStoppageFee: res[0].iStoppageFee.toLocaleString(),

        tiComeBackPercentage: res[0].tiComeBackPercentage.toLocaleString(),

        iSpatialDayPercentage: res[0].iSpatialDayPercentage.toLocaleString(),

        tiCommissionPercentage: res[0].tiCommissionPercentage,

        tiAdvancePaymentPercentage: res[0].tiAdvancePaymentPercentage,

        iEvenOdd: res[0].iEvenOdd.toLocaleString(),

        iPreparation: res[0].iPreparation.toLocaleString(),

        iTraffic: res[0].iTraffic.toLocaleString(),

        tiBadWetherPercentage: res[0].tiBadWetherPercentage,

        tiDiscountPercentage: res[0].tiDiscountPercentage,

        tiMountainousPercentage: res[0].tiMountainousPercentage,

        tiNightlyPercentage: res[0].tiNightlyPercentage,

      })

    }

    else {

      this.mdl_MobileGroup.patchValue({

        iTaxiLon_Tariff: '',

        iInputAmount: 0,

        iPerKm: 0,

        iStoppageFee: 0,

        tiComeBackPercentage: 1,

        iSpatialDayPercentage: 1,

      })

    }

  }

  async submit_Tariff() {

    if (this.mdl_MobileGroup.get('iMobileDomain')?.value == '') return this._tooltip.showError('حوزه خدمت را انتخاب کنید');

    if (this.mdl_MobileGroup.get('tiMobileGroup')?.value == '') return this._tooltip.showError('گروه خودرویی را مشخص کنید');

    if (this.mdl_MobileGroup.invalid) return this._tooltip.showError('فرم را با دقت تکمیل کنید');

    let model = this.mdl_MobileGroup.value;

    if (model.iInputAmount.toString().includes(',')) model.iInputAmount = model.iInputAmount.replace(/,/g, '')

    if (model.iPerKm.toString().includes(',')) model.iPerKm = model.iPerKm.replace(/,/g, '')

    if (model.iStoppageFee.toString().includes(',')) model.iStoppageFee = model.iStoppageFee.replace(/,/g, '');

    if (model.iTraffic.toString().includes(',')) model.iTraffic = model.iTraffic.replace(/,/g, '');

    if (model.iEvenOdd.toString().includes(',')) model.iEvenOdd = model.iEvenOdd.replace(/,/g, '');

    if (model.iPreparation.toString().includes(',')) model.iPreparation = model.iPreparation.replace(/,/g, '');

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`TaxiLon_Tariff_Save`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.bError || res.iResult == 0) return this._tooltip.showError(res.strError);

    this._tooltip.showSuccess('اطلاعات با موفقیت ثبت شد')

    this.mdl_MobileGroup.patchValue({

      iTaxiLon_Tariff: '',

      iMobileDomain: '',

      tiMobileGroup: '',

      iInputAmount: 0,

      iPerKm: 0,

      iStoppageFee: 0,

      tiComeBackPercentage: 0,

      iSpatialDayPercentage: 0,

      tiCommissionPercentage: 0,

      tiAdvancePaymentPercentage: 0,

      iEvenOdd: 0,

      iPreparation: 0,

      iTraffic: 0,

      tiBadWetherPercentage: 0,

      tiDiscountPercentage: 0,

      tiMountainousPercentage: 0,

      tiNightlyPercentage: 0,

    })


  }

}
